import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { FormatJSONString } from '../../@shared/util';
import { BoxShadow, Palette, Sizes } from '../../@shared/palette';


export type TabsContentMetricsBaseProps = {
  metrics: string;
  featureMetrics: string;
}

type TabsContentMetricsProps = TabsContentMetricsBaseProps & {
  isVisible: boolean
}

const TabsContentMetrics = (props: TabsContentMetricsProps) => {
  return <div hidden={!props.isVisible}>
    <Typography sx={{ color: Palette.textColorPrimary, fontSize: Sizes.pageThirdTitle, marginBottom: "10px" }}>Metrics:</Typography>
    <Box sx={{
      padding: "20px",
      color: Palette.textColorPrimary,
      fontSize: Sizes.textPrimary,
      backgroundColor: Palette.backgroundColorPrimary,
      borderRadius: "4px",
      boxShadow: BoxShadow,
      marginBottom: "20px",
      position: "relative"
    }}>
      <pre style={{ margin: 0 }}>
        <code style={{ color: Palette.textColorPrimary }}>
          {FormatJSONString(props?.metrics)}
        </code>
      </pre>
    </Box>
    {
      props?.featureMetrics && <>
        <Typography sx={{ color: Palette.textColorPrimary, fontSize: Sizes.pageThirdTitle }}>Feature Metrics:</Typography>
        <Box sx={{
          padding: "20px",
          color: Palette.textColorPrimary,
          fontSize: Sizes.textPrimary,
          backgroundColor: Palette.backgroundColorPrimary,
          borderRadius: "4px",
          boxShadow: BoxShadow,
          marginBottom: "20px",
          position: "relative"
        }}>
          <pre style={{ margin: 0 }}>
            <code style={{ color: Palette.textColorPrimary }}>
              {FormatJSONString(props?.featureMetrics)}
            </code>
          </pre>
        </Box>
        <span style={{ height: "20px", display: "block" }}></span>
      </>
    }
  </div>
}

export default TabsContentMetrics;
